import { isPortalRole } from "lib/portalRoles";

const DEFAULT_STAFF_FRONTEND_PATH = "/staff";

const STAFF_ROUTE_PREFIXES = [
  "/admin",
  "/amortization",
  "/auth-dashboard",
  "/build-sheets",
  "/costs",
  "/customers",
  "/dashboard",
  "/expenses",
  "/invoices",
  "/inventory",
  "/ledger",
  "/manufacturing",
  "/media/gallery",
  "/parts-bank",
  "/payments",
  "/payroll",
  "/pipeline",
  "/projections",
  "/pull-orders",
  "/purchase",
  "/sales",
  "/settings",
  "/valve-bodies",
  "/vendors",
  "/warehouse",
  "/work-orders",
];

function trimTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

function normalizePath(value) {
  const raw = String(value || "").trim();
  if (!raw || raw === "/") return "/";
  return raw.startsWith("/") ? raw : `/${raw}`;
}

function isLocalFrontendPort() {
  if (typeof window === "undefined") return false;
  return window.location.port === "3000";
}

export function isStaffRole(role) {
  const normalized = String(role || "").trim().toLowerCase();
  return !!normalized && !isPortalRole(normalized);
}

export function isMobileRoutePath(pathname) {
  const path = String(pathname || "");
  return path === "/m" || path.startsWith("/m/");
}

export function isV1StaffRoute(pathname) {
  const path = normalizePath(pathname);
  return STAFF_ROUTE_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

/** Legacy public-web mobile staff UI paths (e.g. /m/dashboard → /dashboard). */
export function isMobileStaffRoute(pathname) {
  const path = normalizePath(pathname);
  if (!isMobileRoutePath(path)) return false;
  const stripped = path === "/m" || path === "/m/" ? "/" : path.replace(/^\/m(?=\/|$)/, "") || "/";
  return isV1StaffRoute(stripped);
}

export function getStaffFrontendUrl(nextPath = "/") {
  const configured = String(process.env.REACT_APP_STAFF_FRONTEND_URL || "").trim();
  const fallbackBase =
    typeof window !== "undefined" && isLocalFrontendPort()
      ? `${window.location.protocol}//${window.location.hostname}:3100`
      : DEFAULT_STAFF_FRONTEND_PATH;
  const base = trimTrailingSlash(configured || fallbackBase);
  const next = normalizePath(nextPath);

  if (/^https?:\/\//i.test(base)) {
    const url = new URL(base);
    url.pathname = `${trimTrailingSlash(url.pathname)}${next === "/" ? "/" : next}`;
    return url.toString();
  }

  return `${base || DEFAULT_STAFF_FRONTEND_PATH}${next === "/" ? "/" : next}`;
}

/**
 * Portal/account entry for public-web surfaces.
 * Staff hard-navigate to staff-erp; customers stay on the customer portal path; guests sign in.
 */
export function navigateAccountPortal({
  token,
  role,
  navigate,
  accountPath = "/m/account",
  signInPath = "/m/authentication/sign-in",
} = {}) {
  if (!token) {
    if (typeof navigate === "function") navigate(signInPath);
    return;
  }
  if (isStaffRole(role)) {
    if (typeof window !== "undefined") {
      window.location.assign(getStaffFrontendUrl("/"));
    }
    return;
  }
  if (typeof navigate === "function") navigate(accountPath);
}
